"use client";

import Image from "next/image";
import Link from "next/link";

function Logo({ className = "" }: { className?: string }) {
  return (
    <Image
      src="/logo-azul.webp"
      alt="A Estrada Dixital"
      width={200}
      height={80}
      priority
      className={`h-12 w-auto ${className}`}
    />
  );
}

const NAV_LINKS = [
  { href: "/#tarifas", label: "Ofertas" },
  { href: "/wifi", label: "WiFi" },
  { href: "/so-fibra", label: "So Fibra" },
  { href: "/fibra-telefonia", label: "Fibra + Telefonía" },
  { href: "/telefonia", label: "Telefonía" },
  { href: "/empresas", label: "Empresas" },
  { href: "/contacto", label: "Contacto" },
  { href: "/area-privada", label: "Área Privada" },
];

export default function Navbar({ active }: { active?: string }) {
  const ctaHref = active === "Contacto" ? "#formulario" : "/contacto";

  return (
    <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link href="/">
          <Logo className="text-[var(--navy)]" />
        </Link>

        {/* Desktop menu */}
        <div className="hidden items-center gap-8 text-sm font-medium text-gray-600 lg:flex">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className={`transition hover:text-[var(--navy)] ${
                active === link.label ? "text-[var(--navy)]" : ""
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <Link
            href={ctaHref}
            className="hidden rounded-full bg-[var(--navy)] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[var(--navy-light)] sm:inline-block"
          >
            Contratar
          </Link>

          {/* Mobile hamburger */}
          <details className="relative lg:hidden">
            <summary className="flex h-10 w-10 cursor-pointer list-none items-center justify-center rounded-lg text-[var(--navy)] transition hover:bg-gray-100 [&::-webkit-details-marker]:hidden">
              <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </summary>

            <div className="fixed left-0 top-[81px] w-full border-t bg-white px-6 py-4 shadow-lg">
              <div className="flex flex-col gap-1">
                {NAV_LINKS.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className={`block rounded-lg px-4 py-2.5 text-sm font-medium transition hover:bg-gray-50 ${
                      active === link.label
                        ? "bg-gray-50 text-[var(--navy)] font-semibold"
                        : "text-gray-600"
                    }`}
                  >
                    {link.label}
                  </a>
                ))}
                <a
                  href={ctaHref}
                  className="mt-2 block rounded-full bg-[var(--navy)] px-5 py-3 text-center text-sm font-semibold text-white transition hover:bg-[var(--navy-light)]"
                >
                  Contratar
                </a>
              </div>
            </div>
          </details>
        </div>
      </div>
    </nav>
  );
}
